export default Object.freeze({
    csrf: {
        fetchFailed: 'Failed to fetch csrf token after 3 retries',
    },
    tracking: {
        addingIpsEventFailed: 'Adding tracking Ips event failed',
        fbEventNotProperlyHandled: "FB Event tracking isn't properly handled",
        capiCallFailed: 'FB capi call failed',
        firePixelFailed: 'Fire pixel failed',
        fireGooglePurchaseFailed: 'Fire Google Purchase failed',
        fireImgPixelFailed: 'Fire img pixel failed',
    },
    checkout: {
        csrfTokenCallFailed: 'Checkout | Csrf token call failed',
        setupStarting: 'Checkout | Starting Setup',
        setupComplete: 'Checkout | Setup Complete',
        setupFailed: 'Checkout | Setup failed',
        serverEmailValidationFailed: 'Checkout | Server email validation failed',
        hostedFieldsSetupStarted: 'Checkout | Hosted Fields setup started',
        hostedFieldsSetupCompleted: 'Checkout | Hosted Fields setup successfully completed',
        hostedFieldsSetupFailed: 'Checkout | Hosted Fields setup failed 5 times',
        hostedFieldsTokenized: 'Checkout | Hosted Fields successfuly tokenized',
        paymentCsrfTokenCallFailed: 'Payment | Csrf token call failed',
        paymentStartProcessing: 'Payment | Starting processing',
        paymentProcessed: 'Payment | Successfully processed',
        paymentFailed: 'Payment | Failed',
        paymentMethodCreated: 'Payment Method | Successfuly created',
        unsupportedCreditCard: 'Unsupported Credit Card Type',
        immediatePaymentStartProcessing: 'Immediate Payment | Starting processing',
        immediatePaymentProcessed: 'Immediate Payment | Successfully processed',
        immediatePaymentTokenFailed: 'Immediate Payment | Create Token Failed',
        immediatePaymentFailed: 'Immediate Payment | Failed',
        immediatePaymetRetryFailed: 'Immediate Payment | Retry Failed',
        updatePaymentMethodCsrfTokenCallFailed: 'Update Payment Method | Csrf token call failed',
        updatePaymentMethodStartProcessing: 'Update Payment Method | Starting processing',
        updatePaymentMethodProcessed: 'Update Payment Method | Successfully processed',
        updatePaymentMethodFailed: 'Update Payment Method | Failed',
        fetchPricesStarted: 'Prices | Starting fetch of prices',
        fetchPricesTryFailed: 'Prices | Failed to fetch prices',
        fetchPricesFailed: 'Prices | Failed to fetch within 5 attempts',
        fetchPricesCompleted: 'Prices | Succesfully fetched',
        createBtClientStarted: 'Braintree | Starting initial client setup',
        createBtClientTryStarted: 'Braintree | Starting creating client instance',
        createBtClientCompleted: 'Braintree | Client instance is created',
        createBtClientTryCompleted: 'Braintree | Succesfully created client instance',
        createBtClientFailed: 'Braintree | Failed to create client instance within 3 attempts',
        createBtClientTryFailed: 'Braintree | Failed to create client instance',
        fetchAsyncBtTokenStarted: 'Braintree | Starting fetch of async-braintree-token',
        fetchAsyncBtTokenTryFailed: 'Braintree | Failed to fetch async-braintree-token',
        fetchAsyncBtTokenFailed: 'Braintree | Failed to fetch async-braintree-token within 5 attempts',
        fetchAsyncBtTokenCompleted: 'Braintree | Succesfully fetched async-braintree-token',
        applePayAuthorizationFailed: 'Checkout | ApplePay | Payment authorization',
        applePayPaymentMethodCreated: 'Checkout | ApplePay | Payment method successfully created',
        applePayPaymentMethodFailed: 'Checkout | ApplePay | Create payment method failed',
        paypalSetupStarted: 'Paypal | Starting Setup',
        paypalSetupCompleted: 'PayPal | Setup Complete',
        paypalLoadSdkStarted: 'PayPal | Starting to load PayPal SDK',
        paypalLoadSdkCompleted: 'PayPal | PayPal SDK Loaded',
        paypalCreateBillingAgreementStarted: 'PayPal | PayPal button clicked, creating billing agreement',
        paypalPaymentApproved: 'PayPal | Payment Approved',
        paypalCancelClicked: 'PayPal | Cancel Clicked',
        paypalPaymentMethodFailed: 'Checkout | PayPal | Create payment method failed',
        paypalTokenizeFailed: 'Checkout | PayPal | Tokenize failed',
        paypalError: 'Checkout | Paypal | Error',
        paypalCheckoutComponentFailed: 'Checkout | Paypal | Create component failed',
        stepOneSubmitClicked: 'Step 1 | Clicked Submit',
        stepOneAlreadyPurchased: 'Step 1 | Already Purchased',
        stepOneComplete: 'Step 1 | Complete',
        stepOneLocalValidationFailed: 'Step 1 | Local email validation failed',
        stepOneCloseButtonClicked: 'Step 1 | Clicked close button',
    },
});
